
export default {
  name: 'PostStandart',

  props: {
    post: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  }
}
